<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">消息详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <div class="contentTop">
                    <div class="icon">
                        <img src="../../assets/images/thstart.png" alt="">
                        <img src="../../assets/images/vipLogo.png" alt="">
                    </div>
                    <div>上领时光（上街店）</div>
                    <div><span>￥-200</span></div>
                    <div>交易成功</div>
                </div>
                <div class="line"></div>
                <div class="contentMain">
                    <div class="msgDetails">
                        <ul>
                            <!-- 遍历 -->
                            <li class="itemDetail" v-for="(value,index) in content.items" :key="index">
                                <span>{{ value.l }}</span>
                                <span>{{ value.r }}</span>
                            </li>
                            <!-- <li class="itemDetail">
                                <span>会员卡号</span>
                                <span class="red">SLSG 1083 4791 656</span>
                            </li>
                            <li class="itemDetail">
                                <span>会员卡号</span>
                                <span>SLSG 1083 4791 656</span>
                            </li>
                            <li class="itemDetail">
                                <span>会员卡号</span>
                                <span class="red">SLSG 1083 4791 656</span>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="goodsList">
                <ul>
                    <li class="goods">
                        <img src="../../assets/images/head.png" alt="">
                        <span>健康蔬菜套餐</span>
                        <span>100039</span>
                        <span>X1</span>
                        <span>¥59.90</span>
                    </li>
                </ul>
                <div class="more">
                    展开更多
                    <img class="arrowBottom" src="../../assets/images/arrowBottom.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio, Navbar, TabItem } from "mint-ui";
import { showMsgAction } from "@/assets/js/api"

export default {
    data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1',
        messageInfo:[],               // 消息详情
        msgId:"",                     // 被选中消息ID
        type: '',
        content:"",  
    };
    },
    computed: {},
    components: {},
    methods: { 
        // 获取消息详情
        getMessageInfo()
        {
            showMsgAction(this.msgId, this.type).then(res => {
                console.log('message',res);
                if (res.s == 0)
                {
                    this.messageInfo = res;
                    this.content     = JSON.parse(this.messageInfo.content);
                    console.log('content',this.content);
                    console.log('messageInfo',this.messageInfo);
                }
            })
        }    
    },
    created()
    {
        this.msgId = this.$route.query.msgId
        this.type = this.$route.query.type
    },
    mounted()
    {
        this.getMessageInfo();
    }          
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
  background-color: #ffffff;  
}
.contentTop{
    width: 9.24rem;
    height: 3.4rem;
    margin-left: 0.39rem;
    position: relative;
}
.contentTop :nth-child(1){
    width: 1.84rem;
    height: 1.84rem;
    position: absolute;
    top: 0.39rem;
    left: 1rem;
}
.contentTop :nth-child(2){
    font-size: 0.37rem;
    position: absolute;
    top: 0.8rem;
    left: 3.45rem;
}
.contentTop :nth-child(3){
    font-size: 0.53rem;
    color: rgba(0, 0, 0, 0.9);
    text-align: center;
    position: absolute;
    top: 2rem;
    left: 3.45rem;
}
.contentTop :nth-child(3) :only-child{
    text-align: center;
    margin-top: -0.5rem;
    margin-left: -1.2rem;
}
.contentTop :nth-child(4){
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 3rem;
    left: 3.65rem;
}
.icon :nth-child(1){
    width: 0.89rem;
    height: 0.89rem;
    border-radius: 2.24rem;
    position: absolute;
}
.icon :nth-child(2){
    width: 0.26rem;
    height: 0.26rem;
    position: absolute;
    top: 1rem;
    left: 1.6rem;
}
.contentMain{
    /* height: 7.84rem; */
    width: 100%;
}
.msgDetails ul{
    margin-top: 0.5rem;
}
.msgDetails ul li{
    height: 0.6rem;
    line-height: 0.53rem;
    font-size: 0.37rem;
}
.itemDetail :nth-child(1){
    float: left;
    margin-left: 0.61rem;
    color: rgba(0, 0, 0, 0.5);
}
.itemDetail :nth-child(2){
    float: right;
    margin-right: 0.29rem;
    color: rgba(0, 0, 0, 0.7);
}
.msgDetails ul :nth-child(3){
    margin-bottom: 0.3rem;
}
.goodsList{
    background-color: #fff;
    height: 3.53rem;
    width: 100%;
    margin-top: 0.2rem;
}
.goods{
    width: 100%;
    height: 2.35rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.2);
    position: relative;
}
.goods :nth-child(1){
    width: 1.84rem;
    height: 1.84rem;
    position: absolute;
    top: 0.26rem;
    left: 0.45rem;
}
.goods :nth-child(2){
    position: absolute;
    top: 0.68rem;
    left: 2.8rem;
}
.goods :nth-child(3){
    position: absolute;
    top: 1.5rem;
    left: 2.8rem;
}
.goods :nth-child(4){
    position: absolute;
    top: 1.5rem;
    left: 4.5rem;
}
.goods :nth-child(5){
    position: absolute;
    top: 1rem;
    right: 0.47rem;
}
.more{
    text-align: center;
    font-size: 0.32rem;
    color: rgba(0, 0, 0, 0.5);
    position: relative;
    top: 0.25rem;
}
.arrowBottom{
    width: 0.33rem;
    height: 0.33rem;
}
.line{
    width: 95%;
    margin-left: 0.53rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    position: relative;
    top: 2.4rem;
}
.red{
    color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/messageDetails/paySuccessDetail.vue